import React, { useEffect, useState } from 'react';
import IconFont from '@/components/icon-font';
import styles from './index.module.css';

interface IModal {
  children: React.ReactNode;
  visible: boolean;
  onClose?: () => void;
  style?: React.CSSProperties;
  wrapStyle?: React.CSSProperties;
  /**
   * 隐藏关闭按钮
   */
  hideClose?: boolean;
}
const Modal = (props: IModal) => {
  const { children, visible = false, onClose, style, wrapStyle, hideClose } = props;
  const [show, setShow] = useState(visible);

  const handleClose = () => {
    onClose && onClose();
    setShow(false);
  };

  useEffect(() => {
    setShow(visible);
  }, [visible]);

  return show ? (
    <div
      className={styles.wrap}
      style={{ ...(wrapStyle || {}) }}
      onClick={(e) => {
        // 仅阻止冒泡到宿主，避免误触；勿 preventDefault，否则会拦截弹层内 <a> 跳转、输入等默认行为
        e.stopPropagation();
      }}
    >
      <div
        className={styles.modal}
        style={{
          ...(style || {}),
        }}
      >
        <div className={styles.content}>
          {!hideClose ? (
            <div className={styles.close} onClick={() => handleClose()}>
              <IconFont name="crossBold" fontSize={24}></IconFont>
            </div>
          ) : null}

          {children}
        </div>
      </div>
    </div>
  ) : null;
};

export default Modal;
